<template>
    <table class="table table-sm table-vcenter">
        <thead>
            <tr>
                <th>Phrase</th>
                <th>Plural</th>
                <th>
                    <button type="button" class="btn btn-sm btn-primary js-bs-tooltip-enabled" @click="addRow()">
                        <i class="fa fa-plus"></i>
                    </button>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="(child, index) in children" :key="child.key">
                <td>
                    <input type="hidden" :name="`children[${index}][id]`" v-model="child.id">
                    <input type="text" :class="inputClass(index, 'phrase')" :name="`children[${index}][phrase]`" v-model="child.phrase">
                    <div v-for="error in fieldErrors(index, 'phrase')" :key="error" class="invalid-feedback">{{ error }}</div>
                </td>
                <td>
                    <input type="text" :class="inputClass(index, 'plural')" :name="`children[${index}][plural]`" v-model="child.plural">
                    <div v-for="error in fieldErrors(index, 'plural')" :key="error" class="invalid-feedback">{{ error }}</div>
                </td>
                <td>
                    <button type="button" class="btn btn-sm btn-alt-secondary js-bs-tooltip-enabled" @click="removeRow(index)">
                        <i class="fa fa-fw fa-times"></i>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script>
export default {
    props: {
        defaultChildren: {
            type: Array,
            default: () => [],
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },

    data() {
        return {
            children: [],
            nextKey: 0,
        };
    },

    mounted() {
        this.children = this.defaultChildren.map((child) => this.newRow(child));

        if (this.children.length === 0) {
            this.addRow();
        }
    },

    methods: {
        addRow() {
            this.children.push(this.newRow());
        },
        removeRow(index) {
            this.children.splice(index, 1);
        },
        newRow(child = {}) {
            return {
                key: this.nextKey++,
                id: child.id ?? '',
                phrase: child.phrase ?? '',
                plural: child.plural ?? '',
            };
        },
        fieldErrors(index, field) {
            return this.errors[`children.${index}.${field}`] ?? [];
        },
        inputClass(index, field) {
            return [
                'form-control',
                {
                    'is-invalid': this.fieldErrors(index, field).length > 0,
                },
            ];
        },
    },
};
</script>
